import { render, staticRenderFns } from "./DriveWithMuvLinesMobile.vue?vue&type=template&id=53b97a53&"
import script from "./DriveWithMuvLinesMobile.vue?vue&type=script&lang=js&"
export * from "./DriveWithMuvLinesMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports